import styled from 'styled-components';
import { COMMON, BACKGROUND, LAYOUT, BORDER } from '../constants';
const Card = styled.div.withConfig({
  displayName: "Card",
  componentId: "sc-1b3n7pa-0"
})(["", " ", " ", " ", ""], COMMON, LAYOUT, BORDER, BACKGROUND);
Card.defaultProps = {
  bg: 'white',
  border: '1px solid',
  borderColor: 'gray.0',
  borderRadius: 2,
  p: 6
};
Card.propTypes = { ...LAYOUT.propTypes,
  ...COMMON.propTypes,
  ...BORDER.propTypes,
  ...BACKGROUND.propTypes
};
Card.displayName = 'Card';
export default Card;